export default __webpack_public_path__ + "static/media/528.dc1df8bf.jpg";